// Coluna esquerda do cardápio do TOTEM (o Balcão usa categorias no topo): "Buscar" como PRIMEIRA opção,
// categorias em cards mais finos com animação na escolhida e, no rodapé, o
// mini-card vermelho SAIR (volta pra tela inicial do totem). Sem "Voltar" nem
// logo no topo — pedido do dono (10/09/2026); o banner cobre o cabeçalho todo.
import { Search } from "lucide-react";

import BotaoSair from "./BotaoSair";

export default function ColunaCategorias({ ctx }) {
  const { autoAtendimento, categoryList, selectedCategory, setSelectedCategory, buscaAberta, setBuscaAberta, setSearchTerm, resetTotem, inatividadeInicioRef, inatividadeMs } = ctx;

  const escolher = (cat) => { setBuscaAberta(false); setSearchTerm(""); setSelectedCategory(cat); };
  const abrirBusca = () => { setBuscaAberta(true); setSearchTerm(""); };

  return (
    <div className="w-48 lg:w-56 bg-zinc-900/95 border-r border-zinc-800 flex flex-col shrink-0" data-e2e="coluna-categorias">
      <style>{`
        @keyframes cat-escolhida { 0% { transform: scale(0.96); } 55% { transform: scale(1.03); } 100% { transform: scale(1); } }
        @keyframes cat-barra { from { height: 0; opacity: 0; } to { height: 60%; opacity: 1; } }
      `}</style>
      <div className="px-2 pt-3 pb-1">
        <p className="text-[10px] font-bold text-zinc-500 uppercase tracking-widest px-3 mb-2">Categorias</p>
      </div>
      <div className="flex-1 overflow-y-auto pb-2 px-2 space-y-1">
        {/* Buscar = 1ª opção */}
        <button
          type="button"
          onClick={abrirBusca}
          data-e2e="cat-buscar"
          className={`w-full text-left px-3 py-2.5 rounded-lg text-sm font-semibold transition-all relative overflow-hidden flex items-center gap-2 ${buscaAberta ? "bg-primary text-primary-foreground shadow-lg" : "text-zinc-300 hover:bg-zinc-800 hover:text-zinc-100"}`}
          style={buscaAberta ? { animation: "cat-escolhida 260ms ease-out" } : undefined}
        >
          <Search className="w-4 h-4 shrink-0" /> Buscar
        </button>
        {categoryList.map((cat) => {
          const ativa = !buscaAberta && selectedCategory === cat;
          return (
            <button
              key={cat}
              type="button"
              onClick={() => escolher(cat)}
              data-e2e="cat-item"
              data-ativa={ativa ? "1" : "0"}
              className={`w-full text-left px-3 py-2.5 rounded-lg text-sm font-semibold transition-all duration-200 relative overflow-hidden ${ativa ? "bg-primary text-primary-foreground shadow-lg" : "text-zinc-300 hover:bg-zinc-800 hover:text-zinc-100"}`}
              style={ativa ? { animation: "cat-escolhida 260ms ease-out" } : undefined}
            >
              {ativa && <span className="absolute left-0 top-1/2 -translate-y-1/2 w-1 rounded-r bg-white/60" style={{ animation: "cat-barra 260ms ease-out both" }} />}
              <span className="relative">{cat}</span>
            </button>
          );
        })}
      </div>
      {autoAtendimento && (
        <div className="p-3 border-t border-zinc-800">
          <BotaoSair onSair={resetTotem} inicioRef={inatividadeInicioRef} timeoutMs={inatividadeMs} ativo />
        </div>
      )}
    </div>
  );
}
